import React, { useReducer } from "react";
import PropTypes from "prop-types";
import { IS_MOBILE } from "../../constants";
import Heading from "../../elements/heading";
import Checkbox from "../../elements/checkbox";
import ImageSlideshow from "../image-slideshow";
import FilterSlide from "./FilterSlide";
import "./style.scss";

// Duration in seconds
const slideshowAnimationDuration = 8;

export default function FilterContent({
  heading,
  filterOptions,
  sliderImages,
  submitText,
  selectedOptions,
  onFilterSelect
}) {
  const [selectedFilters, dispatch] = useReducer(
    (selectedFilters, { type, label, value, categoryType }) => {
      switch (type) {
        case "add":
          return [...selectedFilters, { label, value, categoryType }];
        case "remove":
          return selectedFilters.filter(filter => filter.label !== label);
        default:
          return selectedFilters;
      }
    },
    selectedOptions
  );

  const isSelected = option => {
    const found = selectedFilters.find(
      element => element.label === option.label
    );

    return found ? true : false;
  };

  const onCheck = (isChecked, option) => {
    console.log(option);
    dispatch({
      type: isChecked === true ? "add" : "remove",
      categoryType: option.categoryType,
      label: option.label,
      value: option.value
    });
  };

  return (
    <div className="filter-content">
      <div className="grid">
        <div className="filter-content__wrapper">
          <div className="filter-content__options">
            <div className="filter-content__heading">
              <Heading {...heading} typographyClass="type-h1" />
            </div>
            <div className="filter-content__option-list">
              <div className="filter-option">
                <span className="filter-option__category">
                  {filterOptions.locations.overlineText}
                </span>
                {filterOptions.locations.options.map((option, index) => {
                  return (
                    <Checkbox
                      key={index}
                      label={option.label}
                      checked={isSelected(option)}
                      onChange={isChecked => onCheck(isChecked, option)}
                    />
                  );
                })}
              </div>
              <div className="filter-option">
                <span className="filter-option__category">
                  {filterOptions.types.overlineText}
                </span>
                {filterOptions.types.options.map((option, index) => {
                  return (
                    <Checkbox
                      key={index}
                      label={option.label}
                      checked={isSelected(option)}
                      onChange={isChecked => onCheck(isChecked, option)}
                    />
                  );
                })}
              </div>
            </div>
            <span
              className="filter-content__submit"
              onClick={() => {
                onFilterSelect(selectedFilters);
              }}
            >
              {submitText}
            </span>
          </div>

          {!IS_MOBILE && (
            <div className="filter-content__slideshow">
              <ImageSlideshow
                autoPlay={slideshowAnimationDuration}
                slides={sliderImages}
                render={props => (
                  <FilterSlide {...props} key={props?.slide.image} />
                )}
              ></ImageSlideshow>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

FilterContent.propTypes = {
  heading: PropTypes.object,
  filterOptions: PropTypes.object,
  selectedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      error: PropTypes.bool,
      checked: PropTypes.bool
    })
  ),
  sliderImages: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      logo: PropTypes.string,
      url: PropTypes.string
    })
  ),
  submitText: PropTypes.string,
  onFilterSelect: PropTypes.func
};
